export default __webpack_public_path__ + "img/DVC-blender remote.258288a0.jpg";